export enum WorkOrderStatusSystemName {
    New = 'New',
    Assigned = 'Assigned',
    Dispatched = 'Dispatched',
    SubcontractorDispatched = 'Subcontractor Dispatched',
    //Deprecrated
    Enroute = 'Enroute',
     //Deprecrated
    Onsite = 'Onsite',
     //Deprecrated
    CheckedOut = 'Checked Out',
    InProgress = 'In Progress',
    OnHold = 'On Hold',
     //Deprecrated
    Billed = 'Billed',
    Completed = 'Completed',
    Closed = 'Closed',
    Canceled = 'Canceled',
     //Deprecrated
    Paid = 'Paid',
    Finalised = 'Finalised',
    //Special use
    ResumeAllocation = 'Resume',
    Reverse = 'Reverse'
}

export const ActiveJobStatus = [
    WorkOrderStatusSystemName.Enroute,
    WorkOrderStatusSystemName.Onsite
];
